import { useCallback } from "react";

const useWsEditorEvents = () => {
  return useCallback((data) => {
    if (data.type === "edit_success") {
      console.log("收到内容编辑成功响应:", data.edited_text);
      window.dispatchEvent(
        new CustomEvent("contentEditSuccess", {
          detail: {
            editedText: data.edited_text,
            originalText: data.original_text,
            message: data.message,
            requestId: data.request_id,
            fileId: data.file_id,
          },
        })
      );
      return true;
    }

    if (data.type === "edit_error") {
      console.error("内容编辑失败:", data.message);
      window.dispatchEvent(
        new CustomEvent("contentEditError", {
          detail: {
            message: data.message,
            requestId: data.request_id,
          },
        })
      );
      return true;
    }

    if (data.type === "mermaid_fix_success") {
      console.log("收到Mermaid修复成功响应:", data.fixed_code);
      window.dispatchEvent(
        new CustomEvent("mermaidFixSuccess", {
          detail: {
            fixedCode: data.fixed_code,
            originalCode: data.original_code,
            message: data.message,
            requestId: data.request_id,
          },
        })
      );
      return true;
    }

    if (data.type === "mermaid_fix_error") {
      console.error("Mermaid修复失败:", data.message);
      window.dispatchEvent(
        new CustomEvent("mermaidFixError", {
          detail: {
            message: data.message,
            requestId: data.request_id,
          },
        })
      );
      return true;
    }

    return false;
  }, []);
};

export default useWsEditorEvents;
